import { CartService, CartServiceModule } from '@b2b/common/services';
import { getGiftCardRedemptionsTotal } from '@b2b/common/utils/gift-card';
import angular from 'angular';
import { OrderItemDirectiveModule } from '../item/item.directive';

OrderSummaryDirective.$inject = ['CartService'];
function OrderSummaryDirective(CartService: CartService) {
  OrderSummaryController.$inject = ['$scope', '$state'];
  function OrderSummaryController($scope, $state) {
    $scope.orderSummary = {
      model: [],
      options: {},

      init: function () {
        console.log('$scope.model', $scope.model);
      },

      hasItems: function () {
        return this.model && this.model.length;
      },

      getNormalItemType: function (type) {
        let result = '';

        switch (type.toLowerCase()) {
          case 'addon':
          /* falls through */
          case 'event':
          /* falls through */
          case 'donation':
            result = type;
            break;
          default:
            if (type.toLowerCase().indexOf('membership') > -1) {
              result = 'membership';
            }
            break;
        }

        return result;
      },

      getTotal: function () {
        return CartService.getTotal();
      },

      getRetailTotal: function () {
        return CartService.getRetailTotal();
      },

      getSavings: function () {
        return CartService.getSavings();
      },

      getGiftCardTotal: function () {
        return getGiftCardRedemptionsTotal(CartService.getModel().giftCardRedemptions);
      },

      goToEventsList: function () {
        $state.go('application.programs.list');
        $scope.$emit('Cart::Close');
      },
    };

    $scope.orderSummary.init();
  }

  return {
    restrict: 'A',
    replace: true,
    require: 'ngModel',
    templateUrl: 'common/directives/order/summary/summary.tpl.html',

    link: function ($scope, $element, $attrs, ngModelCtrl) {
      // Modified after controller runs
      ngModelCtrl.$formatters.push(function (modelValue) {
        return modelValue
          ? {
              options: modelValue.options || {},
              model: modelValue.data || [],
            }
          : {
              options: {},
              model: [],
            };
      });

      ngModelCtrl.$render = function () {
        $scope.orderSummary.model = ngModelCtrl.$viewValue.model;
        $scope.orderSummary.options = ngModelCtrl.$viewValue.options;
      };
    },

    controller: OrderSummaryController,
  };
}

export const OrderSummaryDirectiveModule = angular
  .module('acme.common.directive.order.summary', [OrderItemDirectiveModule, CartServiceModule])
  .directive('orderSummary', OrderSummaryDirective).name;
